import {
  Button,
  Modal as AntModal,
  Tabs,
  Table,
} from "antd";
import configFile from "config.json";
import { NotificationManager } from "react-notifications";
import styled from "styled-components";
import { useEffect, useState } from "react";
import axios from "utils/axios";

const StyledTable = styled(Table)`
  .ant-table-thead > tr > th {
    white-space: nowrap !important;
  }
  .ant-table-tbody > tr > td {
    min-width: 120px;
  }
`;

const ModalBodyScroll = styled.div`
  overflow-x: auto;
`;

const UserLogModal = ({
  saveButtonText,
  cancelButtonText,
  isShowModal,
  setIsShowModal,
  instance,
}) => {
  const [activeTab, setActiveTab] = useState("device");
  const [deviceHistory, setDeviceHistory] = useState([]);
  const [eventHistory, setEventHistory] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleCancel = () => {
    setIsShowModal(false);
  };


  const fetchTabData = async (tabKey) => {
    setLoading(true);
    try {
      if (tabKey === "device") {
        const { data: response } = await axios.post(
          `${configFile.PROD_SERVER_URL}/user/listDevices`,
          { username: instance.username }
        );
        const formattedData = response?.data?.[0]?.["Devices"]?.map((item) => {
          const attributes = item["DeviceAttributes"].reduce(
            (acc, inner_item) => ({
              ...acc,
              [inner_item["Name"]]: inner_item["Value"],
            }),
            {}
          );
          return {
            ...attributes,
            DeviceLastAuthenticatedDate: item["DeviceLastAuthenticatedDate"],
            DeviceLastModifiedDate: item["DeviceLastModifiedDate"],
            DeviceKey: item["DeviceKey"],
            DeviceCreateDate: item["DeviceCreateDate"],
          };
        });
        setDeviceHistory(formattedData || []);
      } else if (tabKey === "event") {
        const { data: response } = await axios.post(
          `${configFile.PROD_SERVER_URL}/user/listUserAuthEvents`,
          { username: instance.username }
        );
        const formattedData = response?.data?.[0]?.["AuthEvents"]?.map(
          (item) => {
            return {
              CreationDate: item["CreationDate"],
              EventResponse: item["EventResponse"],
              EventType: item["EventType"],
              ...item["ChallengeResponses"][0],
              ...item["EventRisk"],
              ...item["EventContextData"],
            };
          }
        );
        setEventHistory(formattedData || []);
      }
    } catch (error) {
      NotificationManager.error("Failed to fetch data", "Error");
    } finally {
      setLoading(false);
    }
  };

  const handleTabChange = (key) => {
    setActiveTab(key);
    fetchTabData(key);
  };

  useEffect(() => {
    fetchTabData(activeTab);
  }, [activeTab]);
  
  return (
    <AntModal
      width={1200}
      // onOk={handleCancel}
      footer={[
        <Button key="back" onClick={handleCancel}>
          {cancelButtonText}
        </Button>,
      ]}
      onCancel={handleCancel}
      open={isShowModal}
      okText={saveButtonText}
      cancelText={cancelButtonText}
      okType="primary"
    >
      <Tabs
        activeKey={activeTab}
        onChange={handleTabChange}
        items={[
          {
            label: "Хэрэглэгчийн төхөөрөмжний түүх",
            key: "device",
            children: (
              <ModalBodyScroll>
                <StyledTable
                  dataSource={deviceHistory}
                  loading={loading}
                  size="small"
                  scroll={{ x: "max-content", y: 400 }}
                  style={{ fontSize: "12px" }}
                  columns={[
                    {
                      title: "Device Name",
                      dataIndex: "device_name",
                      whiteSpace: "nowrap",
                      className: "column-no-wrap",
                    },
                    {
                      title: "Device status",
                      dataIndex: "device_status",
                      whiteSpace: "nowrap",
                      className: "column-no-wrap",
                    },
                    {
                      title: "Last IP",
                      dataIndex: "last_ip_used",
                      whiteSpace: "nowrap",
                      className: "column-no-wrap",
                    },
                    {
                      title: "Remembered",
                      dataIndex: "dev:device_remembered_status",
                      whiteSpace: "nowrap",
                      className: "column-no-wrap",
                      render: (_, record) => {
                        return record === "remembered" ? "Yes" : "No";
                      },
                    },
                    {
                      title: "Device owner",
                      dataIndex: "dev:device_owner",
                      whiteSpace: "nowrap",
                      className: "column-no-wrap",
                    },
                    {
                      title: "Last Authenticated",
                      dataIndex: "DeviceLastAuthenticatedDate",
                      whiteSpace: "nowrap",
                      className: "column-no-wrap",
                      render: (date) => new Date(date).toLocaleString(),
                    },
                    {
                      title: "Last Modified",
                      dataIndex: "DeviceLastModifiedDate",
                      whiteSpace: "nowrap",
                      className: "column-no-wrap",
                      render: (date) => new Date(date).toLocaleString(),
                    },
                    {
                      title: "Created Date",
                      dataIndex: "DeviceCreateDate",
                      whiteSpace: "nowrap",
                      className: "column-no-wrap",
                      render: (date) => new Date(date).toLocaleString(),
                    },
                    {
                      title: "Device Key",
                      dataIndex: "DeviceKey",
                      whiteSpace: "nowrap",
                      className: "column-no-wrap",
                    },
                  ]}
                  className="custom-table"
                />
              </ModalBodyScroll>
            ),
          },
          {
            label: "Хэрэглэгчийн эвент түүх",
            key: "event",
            children: (
              <div>
                <Table
                  dataSource={eventHistory}
                  loading={loading}
                  columns={[
                    // Add your columns here
                    {
                      title: "Sign in time",
                      dataIndex: "CreationDate",
                      whiteSpace: "nowrap",
                      className: "column-no-wrap",
                      render: (date) => new Date(date).toLocaleString(),
                    },
                    {
                      title: "Event",
                      dataIndex: "EventType",
                      whiteSpace: "nowrap",
                      className: "column-no-wrap",
                    },
                    {
                      title: "Result",
                      dataIndex: "EventResponse",
                      whiteSpace: "nowrap",
                      className: "column-no-wrap",
                    },
                    {
                      title: "Risk decision",
                      dataIndex: "RiskDecision",
                      whiteSpace: "nowrap",
                      className: "column-no-wrap",
                    },
                    {
                      title: "Challange",
                      dataIndex: "ChallangeName",
                      whiteSpace: "nowrap",
                      className: "column-no-wrap",
                      render: (_, record) => {
                        return (
                          <>
                            {record?.ChallengeName || "-"}:
                            {record?.ChallengeResponse || "-"}
                          </>
                        );
                      },
                    },
                    {
                      title: "IP Address",
                      dataIndex: "IpAddress",
                      whiteSpace: "nowrap",
                      className: "column-no-wrap",
                    },
                    {
                      title: "Location",
                      dataIndex: "City",
                      whiteSpace: "nowrap",
                      className: "column-no-wrap",
                    },
                  ]}
                />
              </div>
            ),
          },
        ]}
      />
    </AntModal>
  );
};

export default UserLogModal;
